<fieldset class="d-flex" [disabled]="!editable()">
	<div class="col-6 px-4">
		<div class="mb-3">
			<mat-form-field class="w-100 mt-3">
				<input
					matInput
					type="text"
					id="name"
					name="name"
					[(ngModel)]="service.data.name"
					[disabled]="!editable()"
					required
				/>
				<mat-label for="name">Nazwa usługi</mat-label>
			</mat-form-field>
		</div>

		<div class="mb-3">
			<mat-form-field class="w-100">
				<input
					matInput
					[disabled]="!editable()"
					type="text"
					id="code"
					name="code"
					[(ngModel)]="service.data.code"
					required
				/>
				<mat-label for="code">Kod</mat-label>
			</mat-form-field>
		</div>
		<div class="mb-3 d-flex">
			<mat-form-field class="w-100">
				<mat-label for="service_type">Rodzaj usługi:</mat-label>
				<mat-select
					id="service_type"
					name="service_type"
					[(ngModel)]="service.data.serviceType"
					[disabled]="!editable()"
					required
				>
					<mat-option disabled>(wybierz)</mat-option>
					<mat-option [value]="item.id" *ngFor="let item of service.mockData.service_type">
						{{ item.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<button mat-raised-button color="primary" [disabled]="!editable()" class="my-3 ms-3" (click)="openDialog()">
				+
			</button>
		</div>
		<div class="mb-3">
			<mat-form-field class="w-100">
				<mat-label for="service_type">Metoda naliczania ceny:</mat-label>
				<mat-select
					id="count"
					name="count"
					[(ngModel)]="service.data.dependsOn"
					[disabled]="!editable()"
					required
				>
					<mat-option disabled>(wybierz)</mat-option>
					<mat-option [value]="item.enum" *ngFor="let item of service.mockData.count">
						{{ item.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="mb-3">
			<mat-form-field class="w-100">
				<mat-label for="service_type">Sposób naliczania:</mat-label>
				<mat-select
					id="method"
					name="method"
					[(ngModel)]="service.data.countingMethod"
					[disabled]="!editable()"
					(ngModelChange)="
						service.data.methodValue = convertPriceByKind(
							service.data.methodValue,
							service.data.countingMethod
						)
					"
					required
				>
					<mat-option disabled>(wybierz)</mat-option>
					<mat-option [value]="item.enum" *ngFor="let item of service.mockData.method">
						{{ item.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="mb-3">
			<mat-form-field class="w-100 mt-3">
				<input
					matInput
					type="number"
					id="methodValue"
					name="methodValue"
					[ngModel]="
						service.data.countingMethod === ServiceCountingMethods.VALUE
							? (service.data.methodValue | price)
							: (service.data.methodValue | PercentValue: 100)
					"
					(ngModelChange)="service.data.methodValue = changeNumber($event)"
					[disabled]="!editable()"
					required
				/>
				<mat-label for="methodValue">Wartość</mat-label>
				<p matSuffix *ngIf="service.data.countingMethod === ServiceCountingMethods.VALUE">PLN</p>
				<p matSuffix *ngIf="service.data.countingMethod === ServiceCountingMethods.PERMILLE">%</p>
			</mat-form-field>
		</div>
		<div class="mb-3">
			<mat-form-field class="w-100">
				<mat-label for="transport">Transport:</mat-label>
				<mat-select
					id="transport"
					name="transport"
					[(ngModel)]="service.data.transport"
					[disabled]="!editable()"
					required
				>
					<mat-option disabled>(wybierz)</mat-option>
					<mat-option [value]="item.enum" *ngFor="let item of service.mockData.transport">
						{{ item.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		@if (service.data.serviceType === RESIGNATION_SERVICE_TYPE) {
			<div class="mb-3">
				<mat-form-field class="w-100">
					<mat-label id="insurer" for="insurer">Ubezpieczyciel:</mat-label>
					<mat-select [formControl]="insurerFormField" required>
						@for (insurer of insurers$ | async; track insurer.id) {
							<mat-option [value]="insurer.id">{{ insurer.name }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
		}
		<div class="my-4">
			<mat-checkbox [(ngModel)]="service.data.isActive" [disabled]="!editable()">Aktywna</mat-checkbox>
		</div>
		<div class="my-3">
			<mat-checkbox [(ngModel)]="service.data.allParticipant" [disabled]="!editable()"
				>Naliczana wszystkim użytkownikom</mat-checkbox
			>
		</div>
	</div>
	<div class="col-6 px-4">
		<div class="my-4">
			<mat-checkbox [(ngModel)]="service.limits" [disabled]="!editable()">Bez ograniczeń</mat-checkbox>
		</div>
		<h6 *ngIf="!service.limits">Okres sprzedaży</h6>
		<div class="mb-3 d-flex" *ngIf="!service.limits">
			<mat-form-field appearance="fill" class="w-50 pe-2">
				<mat-label>Wybierz date</mat-label>
				<input
					[disabled]="!editable()"
					matInput
					[(ngModel)]="service.data.sell.lower"
					[matDatepicker]="datepickerSellLower"
				/>
				<mat-hint>MM/DD/YYYY</mat-hint>
				<mat-datepicker-toggle
					[disabled]="!editable()"
					matSuffix
					[for]="datepickerSellLower"
				></mat-datepicker-toggle>
				<mat-datepicker #datepickerSellLower>
					<mat-datepicker-actions>
						<button mat-button (click)="clear('sell', 'lower')">Wyczyść</button>
						<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
					</mat-datepicker-actions>
				</mat-datepicker>
			</mat-form-field>
			<mat-form-field appearance="fill" class="w-50 ps-2">
				<mat-label>Wybierz date</mat-label>
				<input
					matInput
					[disabled]="!editable()"
					[(ngModel)]="service.data.sell.upper"
					[matDatepicker]="datepickerSellUpper"
				/>
				<mat-hint>MM/DD/YYYY</mat-hint>
				<mat-datepicker-toggle
					[disabled]="!editable()"
					matSuffix
					[for]="datepickerSellUpper"
				></mat-datepicker-toggle>
				<mat-datepicker #datepickerSellUpper>
					<mat-datepicker-actions>
						<button mat-button (click)="clear('sell', 'upper')">Wyczyść</button>
						<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
					</mat-datepicker-actions>
				</mat-datepicker>
			</mat-form-field>
		</div>
		<h6 class="mt-3" *ngIf="!service.limits">Okres wyjazdów</h6>
		<div class="mb-3 d-flex" *ngIf="!service.limits">
			<mat-form-field appearance="fill" class="w-50 pe-2">
				<mat-label>Wybierz date</mat-label>
				<input
					[disabled]="!editable()"
					matInput
					[(ngModel)]="service.data.departures.lower"
					[matDatepicker]="datepickerdeparturesLower"
				/>
				<mat-hint>MM/DD/YYYY</mat-hint>
				<mat-datepicker-toggle
					[disabled]="!editable()"
					matSuffix
					[for]="datepickerdeparturesLower"
				></mat-datepicker-toggle>
				<mat-datepicker #datepickerdeparturesLower>
					<mat-datepicker-actions>
						<button mat-button (click)="clear('departures', 'lower')">Wyczyść</button>
						<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
					</mat-datepicker-actions>
				</mat-datepicker>
			</mat-form-field>
			<mat-form-field appearance="fill" class="w-50 ps-2">
				<mat-label>Wybierz date</mat-label>
				<input
					[disabled]="!editable()"
					matInput
					[(ngModel)]="service.data.departures.upper"
					[matDatepicker]="datepickerdeparturesUpper"
				/>
				<mat-hint>MM/DD/YYYY</mat-hint>
				<mat-datepicker-toggle
					[disabled]="!editable()"
					matSuffix
					[for]="datepickerdeparturesUpper"
				></mat-datepicker-toggle>
				<mat-datepicker #datepickerdeparturesUpper>
					<mat-datepicker-actions>
						<button mat-button (click)="clear('departures', 'upper')">Wyczyść</button>
						<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
					</mat-datepicker-actions>
				</mat-datepicker>
			</mat-form-field>
		</div>

		<div class="mb-3">
			<div class="form-floating mb-3 px-2">
				<h6 matTooltip="Opis który pojawia się na stronie oraz na umowie">Opis</h6>
				<app-editor [(value)]="service.data.description" [disabled]="!editable()"></app-editor>
			</div>
		</div>

		<div class="mb-3">
			<div class="form-floating mb-3 px-2">
				<h6 matTooltip="Notatki dla organizacji/ sprzedaży ">Notatki</h6>
				<app-editor [(value)]="service.data.note" [disabled]="!editable()"></app-editor>
			</div>
		</div>
	</div>
</fieldset>
